module.exports = __webpack_public_path__ + "static/media/warning.47acf667.svg";